import Button from 'common/components/button'

type Props = {
  onClick: () => void
  'data-testid': string
}

const CancelButton = ({ onClick, 'data-testid': dataTestId }: Props) => {
  return (
    <Button onClick={onClick} data-testid={dataTestId} variant="icon">
      Cancel
    </Button>
  )
}

export default CancelButton
